import { Col, Input, InputNumber, Row, Typography } from 'antd';
import React from 'react';
import { IServiceExtraPresentation } from './ServiceExtraForm.props';

const { Text } = Typography;
const { TextArea } = Input;

export const ServiceExtraTechnician: React.FC<IServiceExtraPresentation> = ({
  extra,
  disabled,
  quantity,
  handleQuantityChange,
  handleQuantityBlur,
  handleNameChange,
}) => (
  <>
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={12}><Text className="extra-form-label">Name</Text></Col>
      <Col span={12}><Text className="extra-form-label">Quantity</Text></Col>
    </Row>
    <Row gutter={16} align="middle">
      <Col span={12}>
        <TextArea
          placeholder="Enter name"
          rows={1}
          value={extra.name}
          disabled={disabled}
          autoSize={{ minRows: 1 }}
          onChange={(e: any) => handleNameChange(e.currentTarget.value)}
        />
      </Col>
      <Col span={12}>
        <InputNumber
          min={0}
          step={0.01}
          precision={2}
          value={quantity}
          disabled={disabled}
          onChange={handleQuantityChange}
          onBlur={handleQuantityBlur}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  </>
);
